const isLocalStorageEnabled = () => {
    try {
        var mod = '__storage_test__';
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    } catch(e) {
        return false;
    }
}

const validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
 
//var mixpanel = {track:(value, obj) => {console.log("%c MIXPANEL:", "color: green", value, obj)}, init: () => {}, identify: () => {}, people: {set: () => {}}};

var mixpanel = require('mixpanel-browser');
  
export { isLocalStorageEnabled, validateEmail, mixpanel };


// WEBPACK FOOTER //
// ./components/utils/utils.js